// Org type / scope labels shared by real-API onboarding screens and the MSW
// invitation fixtures. Moved out of mocks/data/onboarding/invitations.ts so the
// production bundle does not import the fixture module (OPT-20261031-05).

export type OrgScope = 'admin' | 'buy' | 'supply'

export type OrgTypeCode =
  | 'A1' | 'A2'
  | 'BO1' | 'BO2' | 'BO3'
  | 'SO1' | 'SO2' | 'SO3'

// ─── Org type labels ──────────────────────────────────────────────────────────

export const ORG_TYPE_LABELS: Record<OrgTypeCode, string> = {
  A1: 'A1 · Platform Owner',
  A2: 'A2 · Internal Staff',
  BO1: 'BO1 · Internal Seller',
  BO2: 'BO2 · Seller',
  BO3: 'BO3 · B2B Buyer',
  SO1: 'SO1 · Own Production',
  SO2: 'SO2 · Production Partner',
  SO3: 'SO3 · Vendor',
}

export const SCOPE_LABELS: Record<OrgScope, string> = {
  admin: 'Admin',
  buy: 'Buy-side',
  supply: 'Supply-side',
}

// BUG-14: canonical org_type → org_scope mapping (shared between FE modal +
// MSW handler for invariant enforcement). Each org_type belongs to exactly
// one scope per D-3 buy/supply/admin split.
export const ORG_TYPE_TO_SCOPE: Record<OrgTypeCode, OrgScope> = {
  A1: 'admin',
  A2: 'admin',
  BO1: 'buy',
  BO2: 'buy',
  BO3: 'buy',
  SO1: 'supply',
  SO2: 'supply',
  SO3: 'supply',
}
